import { ActiveSubscriptionFragment } from 'graphql/generated/graphql';

const endOfTheDay = (date: Date): Date => {
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    23,
    59,
    59,
  );
};

export const isActiveSubscription = (
  subscriptionExpiresAt?: string,
): boolean => {
  if (!subscriptionExpiresAt) return false;

  return endOfTheDay(new Date(subscriptionExpiresAt)) > new Date();
};

export const isInTrial = (
  freeTrialEndsAt: string | null | undefined,
): boolean => {
  if (!freeTrialEndsAt) return false;

  return new Date(freeTrialEndsAt) > new Date();
};

export const isNonRenewing = (
  subscription: ActiveSubscriptionFragment | undefined | null,
): boolean => {
  if (!subscription) {
    return true;
  }
  return (
    isActiveSubscription(subscription.expiresAt) &&
    !!subscription.cancellationScheduledAt
  );
};

export const isScheduledToCancel = (
  subscription: ActiveSubscriptionFragment | undefined,
): boolean => {
  if (!subscription) {
    return false;
  }
  return !!subscription.cancellationScheduledAt;
};
